import { publicConst } from '../config'

export const checkPublic = () => {
	return window.location.href.includes(publicConst)
}
